import {useEffect, useRef, useState} from 'react';

/** Hold a visible placeholder long enough to avoid a one-frame loading flash. */
export default function useMinimumLoading(loading: boolean, minimumMs = 450) {
    const [held, setHeld] = useState(loading);
    const startedAt = useRef(Date.now());
    useEffect(() => {
        if (loading) {
            startedAt.current = Date.now();
            setHeld(true);
            return;
        }
        const remaining = Math.max(0, minimumMs - (Date.now() - startedAt.current));
        const timer = window.setTimeout(() => setHeld(false), remaining);
        return () => window.clearTimeout(timer);
    }, [loading, minimumMs]);
    return loading || held;
}
